import { watch, ref, computed, getCurrentInstance } from 'vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { deepClone, handleClickDevice } from '@blade-sxp/monitoring-center/utils';
import { getRtsp, getRtspMsg } from '@blade-sxp/monitoring-center/api/index';
import { getTaskMsg, getStreamObj, getFaceConfigData } from '@blade-sxp/monitoring-center/utils/setTaskData';
import { NODE_TYPE_DEVICE_GROUP } from '@blade-sxp/monitoring-center/utils/const';
import screenfull from 'screenfull';
const store = useMonitoringStore();
export const useVideoData = () => {
    const vm = getCurrentInstance()?.proxy;
    const selectedBoxIndex = ref(0);
    const isVideoHover = ref(false);
    const dragOverIndex = ref(null);
    const singleScreen = computed(() => store.singleScreen);
    const swappingShown = computed(() => isVideoHover.value && singleScreen.value);
    const fullscreen = computed(() => store.fullScreen);
    let dropBoxIndex = null;
    watch(singleScreen, () => (selectedBoxIndex.value = 0));
    watch(fullscreen, (val) => {
        const element = document.getElementById('container_max'); // 指定全屏区域元素
        if (screenfull.isEnabled) {
            screenfull.request(element);
        }
        screenfull.toggle();
    });
    watch(() => store.videoDetailArr, () => {
        updateVideoSettingData();
    }, {
        deep: true,
    });
    const onFullChange = () => {
        screenfull.on('change', change);
    };
    const change = (e) => {
        console.log(screenfull.isFullscreen, 'screenfull.isFullscreen');
        store.toggleEscfullScreenStatus(!screenfull.isFullscreen);
    };
    const deviceClickListen = () => {
        // 监听设备点击添加视频数据
        watch(() => store.currDeviceId, () => {
            const { currDeviceId, videoDetailArr } = store;
            if (!currDeviceId)
                return;
            const ind = videoDetailArr.findIndex((item) => item.deviceId === currDeviceId);
            if (ind > -1) {
                selectedBoxIndex.value = ind;
            }
            else {
                addVideoData(currDeviceId);
            }
            store.handleCurrDevice('');
        });
    };
    const addVideoData = (deviceId) => {
        // 点击设备新增视频数据
        const { currDeviceNode, videoDetailArr } = store;
        const deepVideoData = deepClone(videoDetailArr);
        const getRtspReq = getRtsp(deviceId).then((rtspData) => rtspData);
        const getRtspMsgReq = getRtspMsg([deviceId]).then((msgData) => msgData);
        Promise.all([getRtspReq, getRtspMsgReq])
            .then(async ([rtspData, taskMsgData]) => {
            const { rtspPreviewAddress } = rtspData;
            const noLayerName = vm?.$t('noLayer');
            const videoStreamMsg = getTaskMsg(taskMsgData[deviceId], noLayerName);
            const videoStreamObj = getStreamObj(currDeviceNode, videoStreamMsg, rtspPreviewAddress);
            await getFaceConfigData(deviceId, videoStreamObj, videoStreamMsg);
            const position = dropBoxIndex || videoDetailArr.findIndex((item) => !item.deviceId);
            dropBoxIndex = null;
            selectedBoxIndex.value = position;
            deepVideoData?.splice(position, 1, videoStreamObj);
            store.updateVideoDatailData(deepVideoData);
            updateVideoSettingData();
        })
            .catch((err) => {
            console.error(err);
        });
    };
    const updateVideoSettingData = () => {
        const { videoDetailArr, videoSettingArr } = store;
        const videoArr = videoDetailArr
            .filter((item) => item.id)
            .map((item) => {
            const existVideo = videoSettingArr.find((setting) => setting.deviceId === item.deviceId) || {};
            const { status, propertyDisplay, linkageDeviceAlertDelayTime, linkageDeviceAlertDuration, currentDeviceAlertDuration } = item.setting;
            return {
                deviceId: item.deviceId || '',
                currentDeviceAlertDuration: currentDeviceAlertDuration || 10,
                linkageDevice: item.setting?.linkageDevices?.[0]?.id,
                status,
                propertyDisplay,
                linkageDeviceAlertDelayTime,
                linkageDeviceAlertDuration,
                animationDelay: 0,
                animationDuration: 0,
                ...existVideo,
            };
        });
        store.updateVideoSettingArrData(videoArr);
    };
    const delVideoData = (deviceId) => {
        const deepVideoData = deepClone(store.videoDetailArr);
        for (let i = 0; i < deepVideoData.length; i++) {
            if (deepVideoData[i].deviceId === deviceId) {
                deepVideoData[i] = {};
                break;
            }
        }
        store.updateVideoDatailData(deepVideoData);
    };
    /** ***设备拖拽start *******/
    // 放开拖拽
    const drop = (index) => {
        const { dragDevice, selectedDevices } = store;
        dragOverIndex.value = null;
        if (!dragDevice?.id || selectedDevices.includes(dragDevice?.id) || dragDevice?.nodeType === NODE_TYPE_DEVICE_GROUP)
            return;
        handleClickDevice(dragDevice, vm);
        dropBoxIndex = index;
    };
    const deviceDragOver = (index) => {
        dragOverIndex.value = index;
    };
    const deviceDragleave = () => {
        dragOverIndex.value = null;
    };
    /** ***设备拖拽end *******/
    // 切换选中框index
    const handleSwapping = (type) => (selectedBoxIndex.value += type ? 1 : -1);
    // 单屏或者当前选中的视频框index
    const showSingleBox = (index) => !singleScreen.value || selectedBoxIndex.value === index;
    const toggleVideoHover = (status) => {
        isVideoHover.value = status;
    };
    return {
        delVideoData,
        deviceClickListen,
        drop,
        handleSwapping,
        showSingleBox,
        toggleVideoHover,
        deviceDragOver,
        deviceDragleave,
        onFullChange,
        selectedBoxIndex,
        singleScreen,
        swappingShown,
        dragOverIndex,
    };
};
